<script>
import { payment } from "@/assets/static.js";
import { active } from "@/assets/static.js";
import { work } from "@/assets/static.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loader from "@/components/custom/Loader.vue";
export default {
  name: "EmployeesModal",
  props: {
    value: Boolean,
    skills: [],
  },
  data() {
    return {
      x: false,
      submitted: false,
      dialog: this.value,
      date: new Date().toISOString().substr(0, 10),
      employeeDate: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menuEmployeeDate: false,
      selectedStatusItems: [],
      selectedPaymenItems: [],
      selectedJobItems: [],
      paymentList: payment,
      activeList: active,
      jobList: work,
      name: "",
      l_name: "",
      department_id: "",
      currentSalary: "",
      email: "",
      birthday: new Date().toISOString().substr(0, 10),
      personal_id: "",
      father_name: "",
      mother_name: "",
      file: null,
      image: null,
      phone: "",
      emergency_number: "",
      emergency_person: "",
      gender: "male",
      password: null,
    };
  },

  watch: {
    value(newValue) {
      this.dialog = newValue;
    },
    dialog(newDialogValue) {
      this.$emit("input", newDialogValue);
    },
    isLoading(isLoading) {
      if (isLoading) {
        this.dialog = true;
      } else {
        this.dialog = false;
      }
    },
  },
  computed: {
    ...mapGetters(["departmentsListGet", "isLoadingGet"]),
    isLoading() {
      return this.isLoadingGet;
    },
  },
  mounted() {},
  methods: {
    ...mapMutations(["SET_LOADING"]),
    ...mapActions(["addEmployee", "getDepartments"]),
    getNameTranslated(item) {
      return this.$t(item.name);
    },
    async addEmployeeFunc() {
      const isValid = await this.$refs.observer.validate();
      // debugger;
      if (isValid) {
        this.SET_LOADING(true);
        const employee = {
          name: this.name,
          l_name: this.l_name,
          currentSalary: this.currentSalary,
          email: this.email,
          birthday: this.birthday,
          personal_id: this.personal_id,
          father_name: this.father_name,
          mother_name: this.mother_name,
          cv: this.file,
          image: this.image,
          phone: this.phone,
          emergency_number: this.emergency_number,
          emergency_person: this.emergency_person,
          gender: this.gender,
          password: this.password,
        };
        this.addEmployee(employee);
      }
    },
    // fillSkills() {
    //   this.$emit("fillSkills", this.skills);
    // },
    getYesterdayDate() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday?.toISOString().substr(0, 10);
    },
  },
  components: {
    Loader,
  },
};
</script>
<style scoped>
.backGround {
  background-color: var(--v-gray2-base) !important;
}
.backGroundCard {
  background-color: var(--v-prime-base) !important;
}
.selectItem {
  color: var(--v-orange-base) !important;
}
.orange-icon ::v-deep .v-icon.mdi {
  color: orange;
}
.v-text-field {
  margin: 3px;
  height: 54px;
  border-radius: 5px;
  background-color: white !important;
}
</style>

<template>
  <v-dialog v-model="dialog" max-width="1000px">
    <Loader ref="loader" v-if="isLoading" />

    <v-card v-else class="backGround">
      <v-card-actions class="justify-end">
        <v-btn color="orange" flat @click.stop="dialog = false">
          <v-icon color="white">mdi-close-thick</v-icon></v-btn
        >
      </v-card-actions>
      <template>
        <v-container>
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-form @submit.prevent="addEmployeeFunc">
              <v-row>
                <v-col cols="12"
                  ><v-row>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="name"
                        :rules="{
                          regex: /^[^\d]+$/u,
                          required: true,
                          max: 255,
                        }"
                      >
                        <v-text-field
                          id="name"
                          v-model="name"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          :label="$t('employeeName')"
                          required
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>

                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="father_name"
                        :rules="{
                          regex: /^[^\d]+$/u,
                          required: true,
                          max: 255,
                        }"
                      >
                        <v-text-field
                          id="fatherName"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="father_name"
                          :label="$t('midName')"
                          required
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="gender"
                        :rules="{
                          regex: /^[^\d]+$/u,
                          required: true,
                          max: 255,
                        }"
                      >
                        <v-radio-group
                          id="gender"
                          v-model="gender"
                          row
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                        >
                          <v-radio
                            color="orange"
                            key="male"
                            :label="$t('male')"
                            value="male"
                          ></v-radio>
                          <v-radio
                            color="orange"
                            key="female"
                            :label="$t('female')"
                            value="female"
                          ></v-radio> </v-radio-group
                      ></validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="l_name"
                        :rules="{
                          regex: /^[^\d]+$/u,
                          required: true,
                          max: 255,
                        }"
                      >
                        <v-text-field
                          id="lastName"
                          v-model="l_name"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          :label="$t('lastName')"
                          required
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="birthday"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            id="birthday"
                            v-model="birthday"
                            :label="$t('dateOfBreath')"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            :hint="$t('dateOfBreath')"
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            color="orange"
                            class="orange-icon"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="birthday"
                          :max="getYesterdayDate()"
                          :rules="[
                            (date) => {
                              date <= new Date().toISOString().substr(0, 10) ||
                                'Date must be before or equal to today';
                            },
                          ]"
                          no-title
                          scrollable
                          color="orange"
                          header-color="orange"
                          class="backGroundCard"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="orange" @click="menu = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="orange"
                            @click="$refs.menu.save(birthday)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="mother_name"
                        :rules="{
                          regex: /^[^\d]+$/u,
                          required: true,
                          max: 255,
                        }"
                      >
                        <v-text-field
                          id="motherName"
                          v-model="mother_name"
                          :error-messages="errors"
                          :rules="{
                            regex: /^[^\d]+$/u,
                            required: true,
                            max: 255,
                          }"
                          :state="errors[0] ? false : valid ? true : null"
                          :label="$t('motherName')"
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="email"
                        :rules="{
                          email: true,
                          required: true,
                        }"
                      >
                        <v-text-field
                          id="email"
                          v-model="email"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          :label="$t('email')"
                          required
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="personal_id"
                        rules="required"
                      >
                        <v-text-field
                          id="personalId"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="personal_id"
                          :label="$t('personalID')"
                          required
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="phone"
                        :rules="{
                          required: true,
                          regex: /^(09|009639|\+9639){1}\d{8}$/,
                        }"
                      >
                        <!--NOTE: here we need to add regular expression condition to make it work with english -->
                        <v-text-field
                          id="phone"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="phone"
                          :label="$t('phone')"
                          required
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="emergency_person"
                        :rules="{
                          regex: /^[^\d]+$/u,
                          max: 255,
                        }"
                      >
                        <v-text-field
                          id="emergencyPerson"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="emergency_person"
                          :label="$t('emergencyPerson')"
                          required
                          outlined
                          color="orange"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="emergencyNumber"
                        :rules="{
                          regex: /^(09|009639|\+9639){1}\d{8}$/,
                        }"
                      >
                        <v-text-field
                          id="emergencyNumber"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="emergency_number"
                          :label="$t('emergencyNumber')"
                          outlined
                          color="orange"
                        ></v-text-field></validation-provider
                    ></v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        v-slot="{ errors, valid }"
                        name="password"
                        :rules="{
                          required: false,
                          min: 8,
                        }"
                      >
                        <v-text-field
                          id="password"
                          v-model="password"
                          :error-messages="errors"
                          :state="errors[0] ? false : valid ? true : null"
                          :label="$t('password')"
                          outlined
                          type="password"
                          color="orange"
                          min="8"
                        ></v-text-field
                      ></validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-file-input
                        id="image"
                        outlined
                        color="orange"
                        ref="fileInput"
                        v-model="image"
                        :label="$t('profile')"
                        accept=".jpg, .png, .gif"
                        class="orange-icon"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                      >
                      </v-file-input>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-file-input
                        id="file"
                        ref="fileInput"
                        v-model="file"
                        :label="$t('cv')"
                        accept=".pdf"
                        class="orange-icon"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                        outlined
                        color="orange"
                      >
                      </v-file-input>
                    </v-col> </v-row
                ></v-col>
              </v-row>

              <v-row class="justify-end">
                <v-btn
                  class="blue ma-4"
                  width="200px"
                  :disabled="invalid"
                  type="submit"
                  id="confirmBtn"
                  @click.prevent="addEmployeeFunc()"
                >
                  <v-icon color="white" class="pa-2">mdi-check-circle</v-icon>
                  <h2 class="white--text">
                    {{ $t("confirm") }}
                  </h2>
                </v-btn>

                <v-btn
                  outlined
                  color="gray0"
                  bordercolor="bordo"
                  class="ma-4"
                  id="deleteEmployeeBtn"
                  width="200px"
                  @click.stop="dialog = false"
                >
                  <v-icon color="bordo" class="pa-2">mdi-account-remove</v-icon>
                  <h3 class="bordo--text">
                    {{ $t("cancel") }}
                  </h3></v-btn
                >
              </v-row>
            </v-form></ValidationObserver
          >
        </v-container>
      </template>
    </v-card>
  </v-dialog>
</template>
